import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

// Create a new context
const ScrollPositionContext = createContext();

// Custom hook to use scroll positions
export const useScrollPosition = () => useContext(ScrollPositionContext);

// Provider component to wrap the entire application
export const ScrollPositionProvider = ({ children }) => {
    const [scrollPositions, setScrollPositions] = useState({});

    // Function to update scroll position for a specific page
    const updateScrollPosition = (page, position) => {
        setScrollPositions(prevPositions => ({
            ...prevPositions,
            [page]: position
        }));
    };

    // Function to restore scroll position for the current page
    const restoreScrollPosition = () => {
        const currentPage = window.location.pathname;
        const position = scrollPositions[currentPage];
        if (position !== undefined) {
            window.scrollTo(0, position);
        } else {
            window.scrollTo(0, 0);
        }
    };

    // Provide the custom hook and functions to child components
    return (
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        <ScrollPositionContext.Provider value={{ updateScrollPosition, restoreScrollPosition }}>
            {children}
        </ScrollPositionContext.Provider>
    );
};

ScrollPositionProvider.propTypes = {
    children: PropTypes.any,

};